import usePermission from 'hooks/usePermission';

import { ACTION_PERMISSIONS, getAvailableActions } from './status';

// Ações disponíveis no status, sem as que o usuário não tem permissão para executar (US12, RN-015).
// A trava de verdade é do backend, que devolve 401; aqui só deixamos de oferecer o que iria falhar.
// Os três `usePermission` são chamados sempre, na mesma ordem — nunca dentro de condição ou laço.
export default function useAllowedActions(slug) {
  const canAnalyze = usePermission(ACTION_PERMISSIONS.startAnalysis);
  const canApprove = usePermission(ACTION_PERMISSIONS.approveData);
  const canReject = usePermission(ACTION_PERMISSIONS.reject);

  const granted = {
    startAnalysis: canAnalyze,
    approveData: canApprove,
    approveEmission: canApprove,
    reject: canReject,
    reopen: canReject,
  };

  return getAvailableActions(slug).filter((action) => granted[action]);
}
